<!--<app-vjs-player [options]="playerOptions"></app-vjs-player>-->
<div class="publisher">
  <div [ngClass]="{'publishing': publishing}" #publisherDiv ></div>
</div>
